<template>
  <div class="person">
    <div class="person__content">
      <template v-if="picturesExist">
        <template v-if="personnelLink">
          <!-- This should be <RouterLink> but it causes too many errors in tests -->
          <a class="person__photo" :href="getPersonURL" @click.prevent="openPersonLink()">
            <span
              :class="`photo-container ${person.pictureUrl ? '' : 'icon-person-circled'}`"
              :style="
                person.pictureUrl && areImagesLoaded ? `background-image: url(${person.pictureUrl}?w=400&fm=webp)` : ''
              "
            ></span>
          </a>
        </template>
        <template v-else>
          <div class="person__photo">
            <span
              :class="`photo-container ${person.pictureUrl ? '' : 'icon-person-circled'}`"
              :style="
                person.pictureUrl && areImagesLoaded ? `background-image: url(${person.pictureUrl}?w=400&fm=webp)` : ''
              "
            ></span>
          </div>
        </template>
      </template>

      <div class="person__details">
        <template v-if="personnelLink">
          <!-- This should be <RouterLink> but it causes too many errors in tests -->
          <a :href="getPersonURL" @click.prevent="openPersonLink()">
            <h3 class="name">{{ person.name }}</h3>
            <b class="title">{{ person.title }}</b>
          </a>
        </template>
        <template v-else>
          <h3 class="name">{{ person.name }}</h3>
          <b class="title">{{ person.title }}</b>
        </template>

        <div class="person__contact">
          <a v-if="person.phone || person.mobile" class="telephone" :href="`tel:${person.phone || person.mobile}`">
            <i class="icon icon-phone-circled"></i>
            <span class="value">{{ person.phone || person.mobile }}</span>
          </a>

          <template v-if="personnelLink">
            <span v-if="person.email" class="email" @click.prevent="openContactForm()">
              <i class="icon icon-mail-circled"></i>
              <span>ota yhteyttä</span>
            </span>
          </template>
          <template v-else>
            <span v-if="person.email" class="email" :href="`mailto:${person.email}`">
              <i class="icon icon-mail-circled"></i>
              <span class="value">{{ person.email }}</span>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { agencies } from '@/app/routes';

export default {
  name: 'person',
  props: {
    office: {
      type: Object,
      required: false,
    },
    person: {
      type: Object,
      required: true,
    },
    personnelLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    picturesExist: {
      type: Boolean,
      required: false,
      default: true,
    },
    areImagesLoaded: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    openPersonLink() {
      void this.$router.push(this.getPersonURL);
    },
    openContactForm() {
      if (this.person && this.office) {
        this.$bus.$emit('openPersonContactDialogue', { person: this.person, office: this.office });
      } else if (this.person && this.person.hasOwnProperty('office')) {
        this.$bus.$emit('openPersonContactDialogue', { person: this.person, office: this.person.office });
      } else {
        void this.$router.push(this.getPersonURL);
      }
    },
  },
  computed: {
    getPersonURL() {
      const id = this.person.shortName || this.person.id || this.person.agentId;
      if (this.office) return `${agencies.path}/${this.office.shortName}/${id}`;
      else return `/valittaja/${id}`;
    },
  },
};
</script>
